import { requestType } from '~/config/enum.config';
var SERVICE = 'domain-service';
var CONTROLLER = 'operatorCallRecordController';
export default {
    /**
     * 通话记录
     */
    getRecordByPersonId: {
        service: SERVICE,
        controller: CONTROLLER,
        action: 'getRecordByPersonId',
        type: requestType.Get
    }
};
